export function getToken () {
    return localStorage.getItem('cloudToken')
}

const tokenName = 'cloudToken'
export { tokenName }

export function getMemberCenterUrl (env) {
    const envConfig = {
        develop: 'http://172.31.2.176:63005',
        dev: 'http://172.31.2.176:63005',
        master: 'https://u.ssjj.cn',
        vpn: 'https://u.ssjj.cn',
        crash: 'https://u-crash.ssjj.cn',
        pre: 'https://u-uat.ssjj.cn',
        test: '',
    }
    return envConfig[env] ? envConfig[env] : envConfig.develop
}

// 获取滚动条宽度,此方法必须在mounted后调用
let scrollWidth

export function getScrollWidth () {
    if (process.server) return
    if (scrollWidth !== undefined) return scrollWidth
    const oDiv = document.createElement('DIV')
    oDiv.style.cssText = 'position:absolute; top:-9999px; width:100px;height:100px; overflow:hidden;'
    const noScroll = document.body.appendChild(oDiv).clientWidth
    oDiv.style.overflowY = 'scroll'
    const scroll = oDiv.clientWidth
    document.body.removeChild(oDiv)
    scrollWidth = noScroll - scroll
    return scrollWidth
}

// 复制文字
export function copyContent (text) {
    let target = null
    target = document.createElement('div')
    target.id = 'tempTarget'
    target.style.opacity = '0'
    target.innerText = text
    document.body.appendChild(target)
    return new Promise((resolve, reject) => {
        try {
            const range = document.createRange()
            range.selectNode(target)
            window.getSelection().removeAllRanges()
            window.getSelection().addRange(range)
            document.execCommand('copy')
            window.getSelection().removeAllRanges()
            target.parentElement.removeChild(target)
            resolve()
        } catch (e) {
            target.parentElement.removeChild(target)
            reject(e)
        }
    })
}

export function isFirefox () {
    return window.navigator.userAgent.indexOf('Firefox') !== -1
}

export function isIdCard (val) {
    return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(val)
}

export function secondsToTime (seconds, type) {
    if (seconds <= 0) {
        if (type == 'time') {
            return '0天0时0分'
        } else if (type == 'day') {
            return [0, 0, 0]
        } else {
            return '0:0:0';
        }
    }
    const daySeconds = 60 * 60 * 24; // 每天的秒数
    const hourSeconds = 60 * 60; // 每小时的秒数
    const minuteSeconds = 60; // 每分钟的秒数

    const days = Math.floor(seconds / daySeconds); // 计算天数
    const hours = Math.floor((seconds % daySeconds) / hourSeconds); // 计算小时数
    const minutes = Math.floor((seconds % hourSeconds) / minuteSeconds); // 计算分钟数

    if (type == 'time') {
        return `${days}天${hours}时${minutes}分`
    } else if (type == 'day') {
        return [days, hours, minutes]
    } else {
        return `${days}:${hours}:${minutes}`
    }
}

export function getUniqueBrowserId () {
    let uid = localStorage.getItem('unique_browser_id'); // 从本地存储中获取 ID
    if (!uid) {
        uid = 'yun-' + new Date().getTime() + Math.random().toString(16).slice(2); // 生成新的 ID
        localStorage.setItem('unique_browser_id', uid); // 将 ID 存储到本地存储中
    }
    return uid;
}

export const DEFAULT_DOWNLOAD_URL = 'https://rescdn.ssjj.cn/client/channel-client/installer/prod/1/4231/423100001/ssjj2-official-20231007_1_4231_423100001.exe';
export const DEFAULT_DOWNLOAD_4399_URL = 'https://my.4399.com/yxssjj2/wd-down';
